import { useRef, useState } from "react";
import { Box, Grid, Typography, Collapse } from "@mui/material";
import TaskIndicatorCard from "../../components/taskIndicatorCard";
import LaddaButton from "../../components/buttons/laddaButton";
import { icons } from "../../constants";
import {
  managementIndicatorComparativeComplianceBySectorTableColumns,
  managementNoPlanningTableColumns
} from "./tableColumns";
import HighchartsComponent from "../../components/highchartsComponent";
import SimpleTable from "../../components/tables/simpleTable";
import { getCurrentMonth } from "../../utils/dateUtils";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SimpleSelect from "../../components/selects/simpleSelect";
import {
  getManagementChartExecutedVsNOProjectedByProcessDATA,
  getManagementExecutedVsNOProjectedByProcessDATA,
  getManagementExecutedVsProjectedByProcessDATA,
  getManagementTableExecutedVsProjectedByProcess,
  getTaskYearsSelect
} from "./getIndicatorData";
import { useEffect } from "react";
import {
  getProcessIdFromUser,
  callApiAsync
} from "../../services/apiService";
import { getCookie } from "../../utils/getCookie";
import { computeWeeksOfMonth } from "../../services/dateService";
import { months } from "../../constants/selectData";
import executedVsPlannedByProcessMANAGEMENT from "../../components/highchartsComponent/charts/executedVsPlannedByProcessMANAGEMENT";
import TaskListDetailModal from "./taskListDetailModal";
import executedVsNoPlannedByProcessMANAGEMENT from "../../components/highchartsComponent/charts/executedVsNoPlannedByProcessMANAGEMENT";

const schema = {};

export default function ManagementIndicatorsPanel({
  isGlobalTaskManagerAdmin = false
}) {
  const [expandedSections, setExpandedSections] = useState({
    section1: false,
    section2: false
  });

  const {
    control,
    watch,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      year: "",
      month: getCurrentMonth(),
      week: "",
      processId: "",

      year2: "",
      month2: getCurrentMonth(),
      week2: "",
      processId2: ""
    }
  });
  const selectedYear = watch("year");
  const selectedMonth = watch("month");
  const weekRange = watch("week");
  const selectedProcess = watch("processId");

  const selectedYear2 = watch("year2");
  const selectedMonth2 = watch("month2");
  const weekRange2 = watch("week2");
  const selectedProcess2 = watch("processId2");

  const [selectedTask, setSelectedTask] = useState(null);
  const [openComments, setOpenComments] = useState(false);
  const [weekOptions, setWeekOptions] = useState([]);
  const [weekOptions2, setWeekOptions2] = useState([]);
  const [detailPage1, setDetailPage1] = useState(1);
  const [detailPage2, setDetailPage2] = useState(1);
  const [detailTotal1, setDetailTotal1] = useState(0);
  const [detailTotal2, setDetailTotal2] = useState(0);
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [chartData2, setChartData2] = useState({});
  const [summary1, setSummary1] = useState(null);
  const [catsData1, setCatsData1] = useState({
    A: "-",
    B: "-",
    C: "-",
    D: "-"
  });
  const [chartData1, setChartData1] = useState({});
  const [type, setType] = useState("");

  const [summary2, setSummary2] = useState(null);
  const [catsData2, setCatsData2] = useState({
    A: "-",
    B: "-",
    C: "-",
    D: "-"
  });

  const [years, setYears] = useState([]);
  const [processOptions, setProcessOptions] = useState([]);

  const ROWS_PER_PAGE = 10;
  const userId = getCookie("sesion")?.id_usuario;

  const lastScrollYRef = useRef(0);
  const freezeScrollPosition = () => {
    lastScrollYRef.current = window.scrollY || 0;
  };
  const restoreScrollPosition = () => {
    window.scrollTo({ top: lastScrollYRef.current, behavior: "auto" });
  };

  const toggleSection = (sectionKey) => {
    freezeScrollPosition();

    setExpandedSections((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey]
    }));
  };

  const handlePageChange1 = (newPage) => {
    getChartExecutedVsProjectedDetail(newPage);
    setDetailPage1(newPage);
  };

  const handlePageChange2 = (newPage) => {
    setDetailPage2(newPage);
    getManagementExecutedVsNOProjectedByProcessDATA(
      selectedYear2,
      selectedMonth2,
      weekRange2,
      setTableData2,
      setDetailTotal2,
      setDetailPage2,
      newPage,
      ROWS_PER_PAGE,
      selectedProcess2
    );
  };

  const getChartExecutedVsProjectedData = () => {
    if (!selectedYear || !selectedMonth) return;
    getManagementExecutedVsProjectedByProcessDATA(
      selectedYear,
      selectedMonth,
      weekRange,
      setChartData1,
      setSummary1,
      setCatsData1,
      selectedProcess
    );

    getManagementTableExecutedVsProjectedByProcess(
      selectedYear,
      selectedMonth,
      weekRange,
      setTableData1,
      setDetailTotal1,
      setDetailPage1,
      detailPage1,
      ROWS_PER_PAGE,
      selectedProcess
    );
  };

  const getChartExecutedVsNOProjectedData = () => {
    if (!selectedYear2 || !selectedMonth2) return;
    getManagementChartExecutedVsNOProjectedByProcessDATA(
      selectedYear2,
      selectedMonth2,
      weekRange2,
      setChartData2,
      setSummary2,
      setCatsData2,
      selectedProcess2
    );

    getManagementExecutedVsNOProjectedByProcessDATA(
      selectedYear2,
      selectedMonth2,
      weekRange2,
      setTableData2,
      setDetailTotal2,
      setDetailPage2,
      detailPage2,
      ROWS_PER_PAGE,
      selectedProcess2
    );
  };

  const getChartExecutedVsProjectedDetail = (page = 1) => {
    getManagementTableExecutedVsProjectedByProcess(
      selectedYear,
      selectedMonth,
      weekRange,
      setTableData1,
      setDetailTotal1,
      setDetailPage1,
      page,
      ROWS_PER_PAGE,
      selectedProcess
    );
  };

  useEffect(() => {
    if (!selectedYear || !selectedMonth) {
      setWeekOptions([]);
      setDetailPage1(1);
      setDetailTotal1(0);
      setValue("week", "");
      return;
    }
    setDetailPage1(1);
    setDetailTotal1(0);
    const weeks = computeWeeksOfMonth(selectedYear, selectedMonth);
    setWeekOptions([{ name: "\u00A0", value: "" }, ...weeks]);

    setValue("week", "");
  }, [selectedYear, selectedMonth, setValue]);

  useEffect(() => {
    if (!selectedYear2 || !selectedMonth2) {
      setWeekOptions2([]);
      setDetailPage2(1);
      setDetailTotal2(0);
      setValue("week2", "");
      return;
    }
    setDetailPage2(1);
    setDetailTotal2(0);
    const weeks = computeWeeksOfMonth(selectedYear2, selectedMonth2);
    setWeekOptions2([{ name: "\u00A0", value: "" }, ...weeks]);

    setValue("week2", "");
  }, [selectedYear2, selectedMonth2, setValue]);

  useEffect(() => {
    getTaskYearsSelect(setYears, setValue);
  }, [setValue]);

  useEffect(() => {
    if (!isGlobalTaskManagerAdmin || !userId) {
      setProcessOptions([]);
      return;
    }
    callApiAsync(
      () => getProcessIdFromUser(userId, true),
      (data) => {
        const displayName = (p) =>
          p.name ?? p.nombre ?? p.label ?? `Proceso ${p.value ?? p.id ?? ""}`;
        const list = (data?.processes ?? []).map((p) => ({
          name: displayName(p),
          value: p.value != null ? String(p.value) : (p.id != null ? String(p.id) : "")
        }));
        setProcessOptions([{ name: "Todos", value: "" }, ...list]);
      }
    );
  }, [isGlobalTaskManagerAdmin, userId]);

  useEffect(() => {
    getChartExecutedVsProjectedData();
  }, [selectedYear, selectedMonth, weekRange, selectedProcess]);

  useEffect(() => {
    getChartExecutedVsNOProjectedData();
  }, [selectedYear2, selectedMonth2, weekRange2, selectedProcess2]);

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "white",
        border: "1px solid #ddd",
        borderRadius: 2,
        p: 3,
        mb: 3,
        minWidth: 0
      }}
    >
      <Box>
        <Typography variant="h6" color="#4444B2" fontWeight="bold" mb={2}>
          Indicador gerencial gestiona tu tiempo
        </Typography>
      </Box>

      <div className="box-border p-15">
        <Typography variant="h6" color="#4444B2" fontWeight="bold" mb={1}>
          Ejecutadas vs planificadas por proceso
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <p className="blueLabelForm">Año:</p>
            <SimpleSelect
              margin={"0"}
              name="year"
              control={control}
              options={years}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <p className="blueLabelForm">Mes:</p>
            <SimpleSelect
              margin={"0"}
              name="month"
              control={control}
              options={months}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <p className="blueLabelForm">Semana:</p>
            <SimpleSelect
              margin={"0"}
              name="week"
              control={control}
              options={weekOptions}
              disabled={weekOptions.length === 0}
            />
          </Grid>
          {isGlobalTaskManagerAdmin && processOptions.length > 0 && (
            <Grid item xs={12} sm={3}>
              <p className="blueLabelForm">Proceso:</p>
              <SimpleSelect
                margin={"0"}
                name="processId"
                control={control}
                options={processOptions}
              />
            </Grid>
          )}
        </Grid>

        <Grid container spacing={2} className="mt-10">
          {(() => {
            const bruto = Number(summary1?.total_projected_units) || 0;
            const eliminadas = Number(summary1?.total_deleted_units) || 0;
            const ejecutadas = Number(summary1?.total_executed_units) || 0;
            const planificadasNetas = Math.max(0, bruto - eliminadas);
            const cumplimientoPct =
              planificadasNetas > 0
                ? Number(((ejecutadas / planificadasNetas) * 100).toFixed(2))
                : (summary1?.compliance_pct ?? 0);
            return (
              <>
                <Grid item xs={12} sm={4}>
                  <TaskIndicatorCard
                    title="Cumplimiento General de Actividades Planificadas"
                    value={(summary1 != null ? String(cumplimientoPct) : "-") + (summary1 != null ? " %" : "")}
                    color="#F9C7C5"
                    height="110px"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TaskIndicatorCard
                    color="#C9F8D1"
                    height="110px"
                    centerContent={
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <div style={{ fontSize: 16, fontWeight: 700, color: "#000" }}>
                          {summary1 != null ? ejecutadas : "-"}
                          <span style={{ fontWeight: 600 }}>
                            {" "}
                            Actividades Ejecutadas
                          </span>
                        </div>
                        <div
                          style={{
                            width: "70%",
                            height: 2,
                            background: "#2F3A80",
                            margin: "10px auto"
                          }}
                        />
                        <div style={{ fontSize: 16, fontWeight: 700, color: "#000" }}>
                          {summary1 != null ? planificadasNetas : "-"}
                          <span style={{ fontWeight: 600 }}>
                            {" "}
                            Actividades Planificadas
                          </span>
                        </div>
               
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TaskIndicatorCard
                    text={summary1?.compliance_message}
                    value=""
                    color={summary1?.compliance_color}
                    height="110px"
                  />
                </Grid>
              </>
            );
          })()}
        </Grid>

        <div className="box-border p-15 mt-20">
          <HighchartsComponent
            options={executedVsPlannedByProcessMANAGEMENT(chartData1)}
          />
        </div>
      </div>

      <div className="j-center">
        <LaddaButton
          variant="contained"
          fontSize="13px"
          onClick={() => toggleSection("section1")}
        >
          <img
            className="btn-icon-20"
            src={icons.task_history}
            alt="icon"
            style={{ marginRight: "10px" }}
          />
          {expandedSections.section1 ? "Ocultar" : "Detalles"}
        </LaddaButton>
      </div>

      <Collapse
        in={expandedSections.section1}
        appear={false}
        onEnter={freezeScrollPosition}
        onEntered={restoreScrollPosition}
      >
        <Box sx={{ mt: 2, p: 2, bgcolor: "#f9f9f9", borderRadius: 1 }}>
          <SimpleTable
            columns={
              managementIndicatorComparativeComplianceBySectorTableColumns
            }
            data={tableData1}
            isPaginated={true}
            onPageChange={handlePageChange1}
            serverPagination={true}
            rowsPerPage={ROWS_PER_PAGE}
            currentPage={detailPage1}
            totalRecords={detailTotal1}
            emptyMessage={"No activities for the selected filters"}
            buttons={[
              {
                type: "tooltip",
                icon: icons.orange_alert_task,
                tooltipContent: (
                  <>
                    <span className="table-default-column ">
                      El indicador de productividad del empleado está por debajo
                      del promedio del área.
                    </span>
                  </>
                )
              },
              {
                type: "icon",
                icon: icons.expediente_blue,
                onClick: (data) => {
                  setType("planned");
                  setOpenComments(true);
                  setSelectedTask(data);
                }
              }
            ]}
          />
        </Box>
      </Collapse>

      <Typography variant="h6" color="#4444B2" fontWeight="bold" mt={2} mb={2}>
        Ejecutadas vs No planificadas por proceso
      </Typography>
      <div className="box-border p-15">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <p className="blueLabelForm">Año:</p>
            <SimpleSelect
              margin={"0"}
              name="year2"
              control={control}
              options={years}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <p className="blueLabelForm">Mes:</p>
            <SimpleSelect
              margin={"0"}
              name="month2"
              control={control}
              options={months}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <p className="blueLabelForm">Semana:</p>
            <SimpleSelect
              margin={"0"}
              name="week2"
              control={control}
              options={weekOptions2}
              disabled={weekOptions2.length === 0}
            />
          </Grid>
          {isGlobalTaskManagerAdmin && processOptions.length > 0 && (
            <Grid item xs={12} sm={3}>
              <p className="blueLabelForm">Proceso:</p>
              <SimpleSelect
                margin={"0"}
                name="processId2"
                control={control}
                options={processOptions}
                label=""
              />
            </Grid>
          )}
        </Grid>

        <Grid container spacing={2} className="mt-10">
          {(() => {
            const bruto = Number(summary2?.total_projected_units) || 0;
            const eliminadas = Number(summary2?.total_deleted_units) || 0;
            const ejecutadas = Number(summary2?.total_executed_units) || 0;
            const noPlanificadasNetas = Math.max(0, bruto - eliminadas);
            const cumplimientoPct2 =
              noPlanificadasNetas > 0
                ? Number(((ejecutadas / noPlanificadasNetas) * 100).toFixed(2))
                : (summary2?.compliance_pct ?? 0);
            return (
              <>
                <Grid item xs={12} sm={4}>
                  <TaskIndicatorCard
                    title="Cumplimiento General de Actividades No Planificadas"
                    value={(summary2 != null ? String(cumplimientoPct2) : "-") + (summary2 != null ? " %" : "")}
                    color="#F9C7C5"
                    height="110px"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TaskIndicatorCard
                    color="#C9F8D1"
                    height="110px"
                    centerContent={
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <div style={{ fontSize: 16, fontWeight: 700, color: "#000" }}>
                          {summary2 != null ? ejecutadas : "-"}
                          <span style={{ fontWeight: 600 }}>
                            {" "}
                            Actividades Ejecutadas
                          </span>
                        </div>
                        <div
                          style={{
                            width: "70%",
                            height: 2,
                            background: "#2F3A80",
                            margin: "10px auto"
                          }}
                        />
                        <div style={{ fontSize: 16, fontWeight: 700, color: "#000" }}>
                          {summary2 != null ? noPlanificadasNetas : "-"}
                          <span style={{ fontWeight: 600 }}>
                            {" "}
                            Actividades No Planificadas
                          </span>
                        </div>
                     
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TaskIndicatorCard
                    text={summary2?.compliance_message}
                    value=""
                    color={summary2?.compliance_color}
                    height="110px"
                  />
                </Grid>
              </>
            );
          })()}
        </Grid>

        <div className="box-border p-15 mt-20">
          <HighchartsComponent
            options={executedVsNoPlannedByProcessMANAGEMENT(chartData2)}
          />
        </div>
      </div>

      <div className="j-center">
        <LaddaButton
          variant="contained"
          fontSize="13px"
          onClick={() => toggleSection("section2")}
        >
          <img
            className="btn-icon-20"
            src={icons.task_history}
            alt="icon"
            style={{ marginRight: "10px" }}
          />
          {expandedSections.section2 ? "Ocultar" : "Detalles"}
        </LaddaButton>
      </div>

      <Collapse
        in={expandedSections.section2}
        appear={false}
        onEnter={freezeScrollPosition}
        onEntered={restoreScrollPosition}
      >
        <Box sx={{ mt: 2, p: 2, bgcolor: "#f9f9f9", borderRadius: 1 }}>
          <SimpleTable
            columns={managementNoPlanningTableColumns}
            data={tableData2}
            isPaginated={true}
            onPageChange={handlePageChange2}
            serverPagination={true}
            totalRecords={detailTotal2}
            rowsPerPage={ROWS_PER_PAGE}
            currentPage={detailPage2}
            emptyMessage={"No hay actividades para los filtros seleccionados"}
            buttons={[
              {
                type: "tooltip",
                icon: icons.orange_alert_task,
                tooltipContent: (
                  <>
                    <span className="table-default-column ">
                      El indicador de productividad del empleado está por debajo
                      del promedio del área.
                    </span>
                  </>
                )
              },
              {
                type: "icon",
                icon: icons.expediente_blue,
                onClick: (data) => {
                  setType("unplanned");
                  setOpenComments(true);
                  setSelectedTask(data);
                }
              }
            ]}
          />
        </Box>
      </Collapse>

      <TaskListDetailModal
        open={openComments}
        onClose={() => setOpenComments(false)}
        user_data={selectedTask}
        defaultDate={new Date()}
        year={selectedYear}
        month={selectedMonth}
        range={weekRange}
        year2={selectedYear2}
        month2={selectedMonth2}
        range2={weekRange2}
        type={type}
      />
    </Box>
  );
}
